import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController, ModalController } from 'ionic-angular';
import { MenuServices } from "../services";
import { Globals } from "../../../globals";
import { DishServices } from "../../dish/services";
import { MenuListPage } from "../menu-list/menu-list";
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';
import { IngredientsServices } from '../../ingredients/services';
import { ProviderOrderAddPage } from '../../providers/orders/provider-order-add/provider-order-add';
import { TranslateService } from '@ngx-translate/core';
import { ProductsServices } from '../../products/services';
import { AddonsTriggerVersionProPage } from '../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { CurrencyPipe } from '@angular/common';
import { QRServices } from '../../services/qrServices';
import { MenuCreateSelectTemplatePage } from '../menu-create/menu-create-select-template/menu-create-select-template';
import { MenuCreateDishSelectPage } from '../menu-create/menu-create-dish-select/menu-create-dish-select';
import { SelectDateTkPickupDay } from '../../components/popups/select-date-tk-pickup-day/select-date-tk-pickup-day';

/**
 * Generated class for the MenuCreateCustomizeViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-menu-create-customize-view',
  templateUrl: 'menu-create-customize-view.html',
})


export class MenuCreateCustomizeViewPage {
  menu_uid: any;
  valueChanges: any;
  valueChanges_dish: any;
  menu: any = Array();
  menu_array: any = Array();
  sections_array: any;
  dish_no_foodcost: boolean = false;
  section_order_show: boolean = false;
  options_menu: boolean = false;
  options_menu_header: boolean = false;
  colors: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public menuServices: MenuServices,
    public globals: Globals,
    public dishServices: DishServices,
    private alertCtrl: AlertController,
    public http: HttpClient,
    public ingredientsServices: IngredientsServices,
    public translate: TranslateService,
    public productServices: ProductsServices,
    private cp: CurrencyPipe,
    public qrServices: QRServices,
    public modalCtrl: ModalController,) {

    this.globals.GAtrackView('Menu', 'Menu - view', this.globals.restaurant.email, 'View', 'View menu', 'Menu', '');

    this.colors = this.globals.getColorsElements();

    this.menu_uid = this.navParams.get('menu_uid');
    this.menuServices.edit = false;

    if (this.globals.checkLimitsByLicense('daily_menu', 'analitycs')) {
      //analytics
      this.analyticsGetTotalMenuSoldWeek();
      //this.stateMenuStock();
      this.average();
    }
    this.checkIfAnyDishNoFoodcosts();

    this.menuServices.menuDoc = this.menuServices.afs.doc('menus/' + this.menu_uid); //Recuperamos el menu
    this.valueChanges = this.menuServices.menuDoc.valueChanges().subscribe(value => {
      if (value) {
        value.UID = this.menu_uid; //Anadimos el UID al plato
        //For amb els plats de la seccio
        this.menuServices.sections_array_tmp = this.globals.objectToArray(value.sections);
        if (value.extras_section) {
          this.menuServices.sections_extra_array_tmp = this.globals.objectToArray(value.extras_section);
        } else {
          this.menuServices.sections_extra_array_tmp = [];
        }
        for (let key in value.sections) {//For sections
          for (let key_dish in value.sections[key].dish) {//For dish
            //comprovar si es dish o product para buscar uno u otro en la bd
            if (value.sections[key].dish[key_dish].type == 'product') {
              this.productServices.productDoc = this.productServices.afs.doc('products/' + value.sections[key].dish[key_dish].uid); //Recuperamos el plato para tener el plato simpre actulizado.
              this.valueChanges_dish = this.productServices.productDoc.valueChanges().subscribe(_value => {
                value.sections[key].dish[key_dish].name = _value.name;
                value.sections[key].dish[key_dish].name_ca = _value.name_ca;
                value.sections[key].dish[key_dish].name_en = _value.name_en;
                value.sections[key].dish[key_dish].name_de = _value.name_de;
                value.sections[key].dish[key_dish].name_fr = _value.name_fr;
                value.sections[key].dish[key_dish].name_it = _value.name_it;
                value.sections[key].dish[key_dish].type = 'product';

                if (_value.description_es) {
                  value.sections[key].dish[key_dish].description_es = _value.description_es;
                } else {
                  value.sections[key].dish[key_dish].description_es = "";
                }
                if (_value.description_ca) {
                  value.sections[key].dish[key_dish].description_ca = _value.description_ca;
                } else {
                  value.sections[key].dish[key_dish].description_ca = "";
                }
                if (_value.description_en) {
                  value.sections[key].dish[key_dish].description_en = _value.description_en;
                } else {
                  value.sections[key].dish[key_dish].description_en = "";
                }
                if (_value.description_de) {
                  value.sections[key].dish[key_dish].description_de = _value.description_de;
                } else {
                  value.sections[key].dish[key_dish].description_de = "";
                }
                if (_value.description_fr) {
                  value.sections[key].dish[key_dish].description_fr = _value.description_fr;
                } else {
                  value.sections[key].dish[key_dish].description_fr = "";
                }
                if (_value.description_it) {
                  value.sections[key].dish[key_dish].description_it = _value.description_it;
                } else {
                  value.sections[key].dish[key_dish].description_it = "";
                }

                if (_value.allergens) {
                  value.sections[key].dish[key_dish].allergens = _value.allergens;
                } else {
                  value.sections[key].dish[key_dish].allergens = [];
                }
                value.sections[key].dish[key_dish].price = _value.pvp;
                if (_value.pvp_supplement) {
                  value.sections[key].dish[key_dish].price_supplement = _value.pvp_supplement;
                } else {
                  value.sections[key].dish[key_dish].price_supplement = 0;
                }
                if (_value.pvp_takeaway) {
                  value.sections[key].dish[key_dish].price_takeaway = _value.pvp_takeaway;
                } else {
                  value.sections[key].dish[key_dish].price_takeaway = 0;
                }
              });

            } else {
              this.dishServices.dishDoc = this.dishServices.afs.doc('dish/' + value.sections[key].dish[key_dish].uid); //Recuperamos el plato para tener el plato simpre actulizado.
              this.valueChanges_dish = this.dishServices.dishDoc.valueChanges().subscribe(_value => {
                value.sections[key].dish[key_dish].name = _value.name_es;
                value.sections[key].dish[key_dish].name_ca = _value.name_ca;
                value.sections[key].dish[key_dish].name_en = _value.name_en;
                value.sections[key].dish[key_dish].name_de = _value.name_de;
                value.sections[key].dish[key_dish].name_fr = _value.name_fr;
                value.sections[key].dish[key_dish].name_it = _value.name_it;
                value.sections[key].dish[key_dish].type = 'dish';

                if (_value.description_es) {
                  value.sections[key].dish[key_dish].description_es = _value.description_es;
                } else {
                  value.sections[key].dish[key_dish].description_es = "";
                }
                if (_value.description_ca) {
                  value.sections[key].dish[key_dish].description_ca = _value.description_ca;
                } else {
                  value.sections[key].dish[key_dish].description_ca = "";
                }
                if (_value.description_en) {
                  value.sections[key].dish[key_dish].description_en = _value.description_en;
                } else {
                  value.sections[key].dish[key_dish].description_en = "";
                }
                if (_value.description_de) {
                  value.sections[key].dish[key_dish].description_de = _value.description_de;
                } else {
                  value.sections[key].dish[key_dish].description_de = "";
                }
                if (_value.description_fr) {
                  value.sections[key].dish[key_dish].description_fr = _value.description_fr;
                } else {
                  value.sections[key].dish[key_dish].description_fr = "";
                }
                if (_value.description_it) {
                  value.sections[key].dish[key_dish].description_it = _value.description_it;
                } else {
                  value.sections[key].dish[key_dish].description_it = "";
                }

                if (_value.allergens) {
                  value.sections[key].dish[key_dish].allergens = _value.allergens;
                } else {
                  value.sections[key].dish[key_dish].allergens = [];
                }
                value.sections[key].dish[key_dish].price = _value.price;
                if (_value.price_supplement) {
                  value.sections[key].dish[key_dish].price_supplement = _value.price_supplement;
                } else {
                  value.sections[key].dish[key_dish].price_supplement = 0;
                }
                if (_value.price_takeaway) {
                  value.sections[key].dish[key_dish].price_takeaway = _value.price_takeaway;
                } else {
                  value.sections[key].dish[key_dish].price_takeaway = 0;
                }
              });
            }
          }
        }

        this.menuServices.menu_tmp = value;
      }
    });
  }

  /**********************************************************/
  /*                    FUNCIONES A NODE                    */
  /**********************************************************/

  public total_menu_sold_week: any = 0;
  async analyticsGetTotalMenuSoldWeek() {
    var menu = await this.menuServices.getMenu(this.menu_uid);
    var date = moment().subtract(7, 'days').format("YYYY-MM-DD");
    //enviar post la peticion y devuelve el plato mas vendido del mes
    this.http.post(this.globals.api_path + 'analytics/menu/total_menu_sold_week?uid=' + this.globals.restaurant_uid
      + '&date=' + date
      + '&name=' + menu.title_es
      , {}, {})
      .subscribe(res => {
        this.total_menu_sold_week = res['total_menu_sold_week'];
      });
    //

  }

  /**********************************************************/
  /*                        FUNCIONES                       */
  /**********************************************************/




  delete() {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-menu'),
      message: this.translate.instant('instant-seguro-quieres-eliminarlo'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            this.globals.GAtrackView('Menu', 'Menu - Delete', this.globals.restaurant.email, 'Delete', 'Delete menu', 'Menu', this.menu_uid);
            if (this.menuServices.filteredMenusActive) {
              this.menuServices.filteredMenus.splice(this.menuServices.filteredMenus.findIndex(item => item.UID == this.menu_uid), 1);
              this.menuServices.filteredMenus = [...this.menuServices.filteredMenus];
            }
            this.menuServices.menus_array.splice(this.menuServices.menus_array.findIndex(item => item.UID == this.menu_uid), 1);
            this.menuServices.menus_array = [...this.menuServices.menus_array];
            this.valueChanges.unsubscribe();
            this.menuServices.delete(this.menu_uid);
            this.redirect();
          }
        }
      ]
    });
    alert.present();
  }





  public list_state_dish_stock: any = [];
  public max_dish_create: any = 0;
  public max_menu_create: any = 0;
  async stateMenuStock() {
    this.list_state_dish_stock = [];
    var menu = await this.menuServices.getMenu(this.menu_uid);
    var max_create = [];
    var _max_dish_create = [];

    //canvios para saber si es dish o product
    for (let section of this.globals.objectToArray(menu.sections)) {
      for (let _dish of this.globals.objectToArray(section.dish)) {
        var dish;

        for (let foodcost of dish.foodcost) {
          var ing = await this.ingredientsServices.getIngredient(foodcost.uid);
          var ing_stock = this.globals.returnBigtoLittleMeasurement(ing.stock, ing.measurement);
          max_create.push(ing_stock / foodcost.quantity_gross);
          this.max_dish_create = Math.min.apply(null, max_create);
          _max_dish_create.push(this.max_dish_create);
        }
        this.list_state_dish_stock.push({
          name: dish.name_es,
          stock: this.max_dish_create,
        });
      }
    }
    this.max_menu_create = Math.min.apply(null, _max_dish_create);
  }

  public average_profit: any = 0;
  public average_cost: any = 0;
  public percent_profit: any = 0;
  async average() {
    var menu = await this.menuServices.getMenu(this.menu_uid);
    var price;
    //Quitamos el tax del precio
    price = this.globals.createSubTotal(menu.price, this.globals.RESTAURANT_TAX);

    this.average_profit = price - menu.menu_cost;
    this.average_cost = menu.menu_cost;

    var foodcost = parseFloat(menu.extra) + parseFloat(menu.menu_cost);
    this.percent_profit = 100 - this.globals.regla3(parseFloat(price), foodcost);
  }

  async checkIfAnyDishNoFoodcosts() {
    //poner plato y producto
    this.dish_no_foodcost = await this.menuServices.checkIfAnyDishNoFoodcost(this.menu_uid);
  }

  async captureScreen() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'print')) { //Si daily_menu->print == true
      this.globals.GAtrackView('Menu', 'Menu - print A4', this.globals.restaurant.email, 'View', 'Print A4', 'Menu', '');

      if (this.globals.tour != '') {
        this.globals.GAtrackView('Tour', 'Tour - Menu - Finish ', this.globals.restaurant.email, 'Finish', 'Tour menu finish', 'Tour', 'Menu');
        this.globals.tour_step_user = -1;
        this.globals.tour = null;
      }

      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-imprimiendo-menu')
      });
      loadingPopup.present();

      //Format values
      var price_format = this.cp.transform(this.menuServices.menu_tmp.price, this.globals.user_currency, true, '0.2-2', 'es')
      var logo_format;

      if (!this.globals.logo_url) {
        logo_format = '';
      } else {
        await this.globals.logo_url.subscribe(data => {
          logo_format = data;
        });
      }

      //Watermark addon comprovation
      var watermark = 'true';
      if (!this.globals.checkLimitsByLicense('daily_menu', 'watermark')) {
        watermark = 'false';
      }

      //Format object menu for POST send
      var menu_send = this.menuServices.menu_tmp;
      this.http.post(this.globals.api_path + 'menu/a4',
        {
          menu: menu_send,
          price_format: price_format,
          logo: logo_format,
          lang: this.menuServices.menu_lang,
          watermark: watermark,
          tax: this.globals.user_tax_name,
        }
        , {})
        .subscribe(res => {
          if (this.globals.so_mobile) {
            window.location.assign(String(res['file']));
          } else {
            window.open(String(res['file']), '_blank');
          }
          loadingPopup.dismiss();
        }, error => {
          loadingPopup.dismiss();
        });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async a5() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'print')) { //Si daily_menu->print == true
      /*
          * Crearemos una api en laravel para la impression en pdf de los menus.
          * */

      this.globals.GAtrackView('Menu', 'Menu - A5', this.globals.restaurant.email, 'View', 'Print A5', 'Menu', '');

      let loadingPopup = this.loadingCtrl.create({
        spinner: 'crescent',
        content: this.translate.instant('instant-imprimiendo-menu')
      });
      loadingPopup.present();

      //Format values
      var price_format = this.cp.transform(this.menuServices.menu_tmp.price, this.globals.user_currency, true, '0.2-2', 'es')
      var logo_format;

      if (!this.globals.logo_url) {
        logo_format = '';
      } else {
        await this.globals.logo_url.subscribe(data => {
          logo_format = data;
        });
      }

      //Watermark addon comprovation
      var watermark = 'true';
      if (!this.globals.checkLimitsByLicense('daily_menu', 'watermark')) {
        watermark = 'false';
      }


      //Format object menu for POST send
      var menu_send = this.menuServices.menu_tmp;
      this.http.post(this.globals.api_path + 'menu/a5',
        {
          menu: menu_send,
          price_format: price_format,
          logo: logo_format,
          lang: this.menuServices.menu_lang,
          watermark: watermark,
          tax: this.globals.user_tax_name,
        }, {})
        .subscribe(res => {
          if (this.globals.so_mobile) {
            window.location.assign(String(res['file']));
          } else {
            window.open(String(res['file']), '_blank');
          }
          loadingPopup.dismiss();
        }, error => {
          loadingPopup.dismiss();
        });
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  print() {
    if (this.globals.checkLimitsByLicense('daily_menu', 'print')) { //Si daily_menu->print == true
      this.globals.GAtrackView('Menu', 'Menu - Print', this.globals.restaurant.email, 'View', 'Print menu', 'Menu', '');
      window.open(this.globals.share_path + this.globals.domini_sites + '/menu/' + this.menuServices.menu_tmp.UID + '?lang=' + this.globals.restaurant.lang + '&print=true', '_blank');
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  async generateGR() {
    this.qrServices.generateMenuCartaGR(this.menu_uid, 'menu');
  }

  async updateIonToggle(type, value) {
    switch (type) {
      case 'enumerate': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'enumerate': value,
        });
        break;
      }
      case 'logo_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'logo_show': value,
        });
        break;
      }
      case 'caption_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'caption_show': value,
        });
        break;
      }
      case 'footer_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'footer_show': value,
        });
        break;
      }
      case 'section_show': {
        await this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
          'section_show': value,
        });
        break;
      }
      case 'tk_active': {
        if (this.globals.checkLimitsByLicense('tpv', 'takeaway')) {
          this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'tk_active': value,
          });
        } else {
          this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        break;
      }
      case 'digital_app': {
        if (this.globals.checkLimitsByLicense('daily_menu', 'digital_daily_menu')) {
          this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'digital_app': value,
          });
        } else {
          this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        break;
      }
      case 'pos_favourite': {
        if (this.globals.checkLimitsByLicense('daily_menu', 'favourites')) {//version pro abierto
          this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'pos_favourite': value,
          });
        } else {
          this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        break;
      }
      case 'tpv_active': {
        if (this.globals.checkLimitsByLicense('daily_menu', 'activable_tpv')) {
          this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
            'tpv_active': value,
          });
        } else {
          this.navCtrl.push(AddonsTriggerVersionProPage);
        }
        break;
      }
    }
  }

  reorderSections(indexes) {
    let element = this.menuServices.sections_array_tmp[indexes.from];
    this.menuServices.sections_array_tmp.splice(indexes.from, 1);
    this.menuServices.sections_array_tmp.splice(indexes.to, 0, element);
  }

  updateSectionOrder() {
    var _obj = {};
    for (var i = 0; this.menuServices.sections_array_tmp.length > i; i++) {
      _obj[i] = {
        name: this.menuServices.sections_array_tmp[i].name || '',
        name_ca: this.menuServices.sections_array_tmp[i].name_ca || '',
        name_de: this.menuServices.sections_array_tmp[i].name_de || '',
        name_en: this.menuServices.sections_array_tmp[i].name_en || '',
        name_fr: this.menuServices.sections_array_tmp[i].name_fr || '',
        name_it: this.menuServices.sections_array_tmp[i].name_it || '',
        order: i,
        dish: this.menuServices.sections_array_tmp[i].dish,
      };
    }
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'sections': _obj,
    });
    this.showSectionOrder();
  }

  showSectionOrder() {
    if (!this.section_order_show) {
      this.section_order_show = true;
    } else {
      this.section_order_show = false;
    }
  }

  /**********************************************************/
  /*                         NAVCTRL                        */
  /**********************************************************/

  async redirect() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    await this.globals.delay(1000);
    this.navCtrl.setRoot(MenuListPage);
    loadingPopup.dismiss();
  }

  openProviderOrderAdd() {
    this.navCtrl.push(ProviderOrderAddPage, {
      element: this.menu_uid,
      type: 'menu'
    });
  }

  selectTemplate() {
    this.navCtrl.push(MenuCreateSelectTemplatePage, {
      update_state: true,
      menu_uid: this.menu_uid,
      template_name: this.menuServices.menu_tmp.template_name,
    });
  }

  openNewSection() {
    this.navCtrl.push(MenuCreateDishSelectPage, {
      type: this.menuServices.menu_tmp.style,
      section: Object.keys(this.menuServices.menu_tmp.sections).length,
      section_complete: this.menuServices.menu_tmp.sections,
      update: true,
      menu_uid: this.menu_uid,
      menu: this.menuServices.menu_tmp,
      new: true,
    });
  }

  openModalVersionPro() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

  onChangeLang(value) {
    //no cambiar seleccionado
    value.target.value = this.globals.restaurant.lang;
    //
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

  openVersionPro() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

  updateIonToggleFeatured(value) {
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'featured': value,
    });
  }

  showMenuOptions() {
    if (this.options_menu) {
      this.options_menu = false;
    } else {
      this.options_menu = true;
    }
  }

  showMenuOptionsHeader() {
    if (this.options_menu_header) {
      this.options_menu_header = false;
    } else {
      this.options_menu_header = true;
    }
  }

  license() {
    this.navCtrl.push(AddonsTriggerVersionProPage);
  }

  changeTkPickupDay() {
    let modal = this.modalCtrl.create(SelectDateTkPickupDay, {
      tk_pickup_day: this.menuServices.menu_tmp.tk_pickup_day,
      element: this.menuServices.menu_tmp,
      type: 'menu'
    });
    modal.present();
  }

  setColor(color) {
    this.menuServices.afs.collection('menus').doc(this.menu_uid).update({
      'pos_background_color': color.pos_background_color,
      'pos_border_color': color.pos_border_color,
      'pos_color_name': color.name
    });
  }
  setBackgroundColor(menu) {
    return {
      'background-color': menu.pos_background_color,
      'border': '1px solid ' + menu.pos_border_color,
      'margin-left': '9px',
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/menu/menu-view/menu-create-customize-view.ts